import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ClinicPage from './pages/ClinicPage';
import './index.css'; // если есть стили
import SpecialistsPage from './pages/SpecialistsPage';
import SpecialistPage from './pages/SpecialistPage';
import ConfirmBookingPage from './pages/ConfirmBookingPage';
import BookPage from './pages/BookPage';
import ConfirmationPage from './pages/ConfirmationPage';
import ErrorPage from './pages/ErrorPage';
import ReviewPage from './pages/ReviewPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:clinicId" element={<ClinicPage />} />
        <Route path="/:clinicId/:serviceId" element={<SpecialistsPage />} />
        <Route path="/:clinicId/:serviceId/:specId" element={<SpecialistPage />} />
        <Route path="/:clinicId/:serviceId/:specId/book" element={<BookPage />} />
        <Route path="/review" element={<ReviewPage />} />
        <Route path="/booking/:clinicId/:serviceId/:specId/confirm" element={<ConfirmBookingPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/error" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}
